<template>
  <div
    id="home"
    role="tabpanel"
    data-mh="log-tab"
    class="tab-pane active"
  >
    <div class="title h6">
      Register
    </div>
    <form
      class="content"
      @submit.prevent="addUser"
    >
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="form-group label-floating is-empty">
            <label class="control-label">Username</label>
            <input
              v-model="newUser.username"
              placeholder=""
              type="text"
              class="form-control"
            >
          </div>
          <div class="form-group label-floating is-empty">
            <label class="control-label">Your Password</label>
            <input
              v-model="newUser.password"
              placeholder=""
              type="password"
              class="form-control"
            >
          </div>
          <div class="form-group date-time-picker label-floating">
            <label class="control-label">Confirm Password</label>
            <input
              v-model="newUser.confirmPassword"
              placeholder=""
              type="password"
              class="form-control"
            >
          </div>
          <div class="form-group label-floating is-empty">
            <label class="control-label">App</label>
            <input
              v-model="newUser.db"
              placeholder=""
              type="text"
              class="form-control"
            >
          </div>
          <button
            id="signup-button"
            class="btn btn-purple btn-lg full-width"
            type="submit"
            name="submit"
          >
            <span>Complete Registration!</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import '../../../js/jquery-3.2.1'
// import '../../../js/material.min'
// import '../../../js/material-init'

export default {
  name: 'RegisterForm',
  data () {
    return {
      newUser: {
        username: '',
        password: '',
        confirmPassword: '',
        db: ''
      }
    }
  },
  computed: {
    // eslint-disable-next-line
      validation: () => {
      return {
        username: !!this.newUser.username.trim(),
        // emaillength: this.newUser.email.trim().length <= this.maxLength,
        // emailformat: this.emailRE.test(this.newUser.email),
        password: !!this.newUser.password.trim(),
        // passwordstrength: this.passwordScore >= this.minPasswordScore,
        // passwordlength: this.newUser.password.trim().length <= 12,
        confirmpassword: !!this.newUser.confirmPassword.trim(),
        passwordsmatch: this.newUser.password.trim() === this.newUser.confirmPassword.trim(),
        db: this.newUser.db
      }
    },
    isValid: () => {
      const validation = this.validation
      // eslint-disable-next-line
        return Object.keys(validation).every((key) => {
        return validation[key]
      })
    }
  },
  methods: {
    // eslint-disable-next-line
      addUser: function() { // !!!! this messes up if I use arrow function
      // if (this.isValid) {
      // const credentials = {
      //   username: this.newUser.username,
      //   password: this.newUser.password,
      //   db: this.newUser.db,
      //   role: 'ADMIN'
      // }
      // this.$store.dispatch('account/signup', credentials)

      // use this component's context to properly use http call
      // pass credentials object and route redirect after finished authenticating
      // auth.signup(this, credentials);
      // }
    }
  }
}
</script>
